import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {InvalidateSubject} from "@shared/helpers/invalidate.subject";
import {DynamicFieldItem} from "@shared/components/dynamic-form/dynamic-form-item";
import {Subject} from "rxjs";
import {DialogService} from "@shared/services/dialog-service";
import {DynamicFormType} from "@shared/components/dynamic-form/dynamic-form-container/dynamic-form-container.component";
import {takeUntil} from "rxjs/operators";
import {DialogModel} from "@shared/models/dialog.model";
import {Guid} from "guid-typescript";

@Component({
    standalone: false,
    selector: 'particle-arrangement-chart-collapsible-form',
  templateUrl: './arrangement-chart-collapsible-form.component.html',
  styleUrls: ['./arrangement-chart-collapsible-form.component.scss']
})
export class ArrangementChartCollapsibleFormComponent implements OnInit, DynamicFormType {
  private _formFieldsErrorInformation: any;
  private _formFieldsValidationState: any;
  formField: DynamicFieldItem;
  sourceType: string;
  endpointName: string;
  item: any;
  showOriginal: boolean;
  showDelete: boolean;
  invalidateSubject: InvalidateSubject;
  showLanguageOption: boolean;
  designMode: boolean;
  editedFields: string[];
  valueChanged: EventEmitter<any> = new EventEmitter();
  errorFieldCount: any;
  set formFieldsErrorInformation(fieldError: any) {
    if (fieldError && this.formField && this.item) {
      this._formFieldsErrorInformation = fieldError;
      const key = this.formField.headerKey + '__' + this.item.id;
      this.errorFieldCount = {
        totalFields: fieldError[key] ? fieldError[key].totalFields : 0,
        totalMandatoryFields : fieldError[key] ? fieldError[key].totalMandatoryFields : 0,
        totalEmptyFields: fieldError[key] ? fieldError[key].totalEmptyFields  : 0,
        totalEmptyMandatoryFields: fieldError[key] ? fieldError[key].totalEmptyMandatoryFields  : 0,
        totalFieldsError: fieldError[key] ? fieldError[key].totalFieldsError  : 0,
        totalMandatoryFieldsError: fieldError[key] ? fieldError[key].totalMandatoryFieldsError  : 0,
        totalCorrectlyFilledUpFields: fieldError[key] ? fieldError[key].totalCorrectlyFilledUpFields   : 0,
        totalMandatoryCorrectlyFilledUpFields : fieldError[key] ? fieldError[key].totalMandatoryCorrectlyFilledUpFields   : 0
      };
    }
  }
  get formFieldsErrorInformation() {
    return this._formFieldsErrorInformation;
  }

  set formFieldsValidationState(fieldValidation: any) {
    if (fieldValidation) {
      this._formFieldsValidationState = fieldValidation;
    }
  }
  get formFieldsValidationState() {
    return this._formFieldsValidationState;
  }
  showViewDetails = false;
  isFirstTopicItem: boolean;
  isExpanded: boolean;
  unsubscibes$ = new Subject<void>();
  constructor(private dialogService: DialogService) {
    this.isFirstTopicItem = true;
    this.isExpanded = false;
  }

  ngOnInit() {
    if(this.item.cells['FormId'] && this.item.cells['FormId'].value &&
      this.item.cells['ItemId'] && this.item.cells['ItemId'].value &&
      this.item.cells['FormId'].value === this.item.cells['ItemId'].value){
      this.showViewDetails = true;
    }
    this.isExpanded = this.formField.isExpanded;
  }
  onValueChanged(event) {
    this.valueChanged.emit(event);
  }
  onDeleteItemClick() {
    const event = {item: this.item, editedFields: this.editedFields, sourceType: this.sourceType, action: 'Delete'};
    this.valueChanged.emit(event);
  }
  doAction(actionType: string) {
    console.log(actionType);
    this.valueChanged.emit({action: actionType, formField: this.formField});
  }

  changeExpand(isExpanded: boolean) {
    this.isExpanded = isExpanded;
    this.formField.isExpanded = isExpanded;
  }

  openHeaderDetails(header: string, headerDetails: string){
    event.stopPropagation();
    this.dialogService.showDialogMessage(header , headerDetails ).pipe(takeUntil(this.unsubscibes$)).subscribe(data => {
      if (data.action === 'OK') {

      }
    });
  }

  hasFormFieldsErrorInformation() {
    return (this.formFieldsErrorInformation && this.formFieldsErrorInformation[this.formField.headerKey + '__' + this.item.id] && this.formFieldsErrorInformation[this.formField.headerKey + '__' + this.item.id].totalEmptyMandatoryFields);
  }

  ngOnDestroy(): void {
    this.unsubscibes$.next();
    this.unsubscibes$.complete();
  }
  openGridView(){
    const dialogModel: DialogModel = DialogModel.create(
      'Arrangement Chart Grid',
      'ArrangementChartGridViewDialogComponent', {
        sourceType: 'DAC6-ArrangementChartGrid-Config',
        formId: this.item.cells['ItemId'].value,
        parentId: this.item.id
      }
    );
    dialogModel.minWidth = '1300px';
    dialogModel.maxWidth = '1300px';
    this.dialogService.showOkCancelDialog(dialogModel).pipe(takeUntil(this.unsubscibes$)).subscribe((item: any)=>{
      this.invalidateSubject.invalidate('Refresh|' + Guid.create().toString());
    });
  }
}
